import { createFileRoute } from '@tanstack/react-router';
import { VideoPlayer } from '@/components/shared/video-player';
import { CLEANER_TUTORIAL_VIDEO } from '@/constants';

export const Route = createFileRoute('/video')({
  component: VideoPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      embed: search.embed as string | undefined,
      ratio: search.ratio as string | undefined,
    };
  },
});

function VideoPage() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', maxWidth: '100%' }}>
        <VideoPlayer src={CLEANER_TUTORIAL_VIDEO} className="rounded-none" />
      </div>
    </div>
  );
}
